import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_count_down = _resolveComponent("count-down");

  const _component_van_cell = _resolveComponent("van-cell");

  const _component_van_cell_group = _resolveComponent("van-cell-group");

  return $data.available ? (_openBlock(), _createBlock(_component_van_cell_group, {
    key: 0,
    title: $props.events.name,
    inset: ""
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.eventsResult, event => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: event
      }, [event.state ? (_openBlock(), _createBlock(_component_van_cell, {
        key: 0,
        title: event.name,
        label: event.desc,
        center: ""
      }, {
        "right-icon": _withCtx(() => [_createVNode(_component_count_down, {
          time: event.time,
          state: event.state,
          class: _normalizeClass({
            periodic: event.periodic,
            coming: event.state == _ctx.$t('common.eventStart'),
            started: event.state == _ctx.$t('common.eventEnd'),
            urgent: event.state == _ctx.$t('common.eventEnd') && event.time <= 86400000
          })
        }, null, 8, ["time", "state", "class"])]),
        _: 2
      }, 1032, ["title", "label"])) : _createCommentVNode("", true)], 64);
    }), 128))]),
    _: 1
  }, 8, ["title"])) : _createCommentVNode("", true);
}